import { MessageDescriptor } from 'react-intl';
import { EAncillaryType } from '../../contexts/Cart/types';

export const ancillaryPurchaseScope = 'app.containers.ancillaryPurchase';

export const ancillaryPurchaseMessages = {
  title: {
    id: `${ancillaryPurchaseScope}.title`,
    defaultMessage: 'Ajouter des options',
    en: 'Add options',
    es: 'Añadir opciones',
    it: 'Aggiungi opzioni',
    de: 'Optionen hinzufügen',
    nl: 'Opties toevoegen',
  },
  booking: {
    id: `${ancillaryPurchaseScope}.booking`,
    defaultMessage: 'Votre réservation {trip}',
    en: 'Your booking {trip}',
    es: 'Tu reserva {trip}',
    it: 'La tua prenotazione {trip}',
    de: 'Ihre Buchung {trip}',
    nl: 'Uw boeking {trip}',
  },
  bookingDetails: {
    id: `${ancillaryPurchaseScope}.bookingDetails`,
    defaultMessage:
      '{date} · {count, plural, one {# passager} other {# passagers}}',
    en: '{date} · {count, plural, one {# passenger} other {# passengers}}',
    es: '{date} · {count, plural, one {# pasajero} other {# pasajeros}}',
    it: '{date} · {count, plural, one {# passeggero} other {# passeggeri}}',
    de: '{date} · {count, plural, one {# Reisender} other {# Reisende}}',
    nl: '{date} · {count, plural, one {# reiziger} other {# reizigers}}',
  },
  cfarTitle: {
    id: `${ancillaryPurchaseScope}.cfarTitle`,
    defaultMessage: 'Option remboursement',
    en: 'Refund option',
    es: 'Opción de reembolso',
    it: 'Opzione rimborso',
    de: 'Erstattungsoption',
    nl: 'Terugbetalingsoptie',
  },
  lastMinuteTitle: {
    id: `${ancillaryPurchaseScope}.lastMinuteTitle`,
    defaultMessage: 'Last minute',
    en: 'Last minute',
    es: 'Last minute',
    it: 'Last minute',
    de: 'Last minute',
    nl: 'Last minute',
  },
  zenRelaxTitle: {
    id: `${ancillaryPurchaseScope}.zenRelaxTitle`,
    defaultMessage: 'Zen & Relax',
    en: 'Zen & Relax',
    it: 'Zen & Relax',
    es: 'Zen & Relax',
    de: 'Zen & Relax',
    nl: 'Zen & Relax',
  },
  cfarItem: {
    id: `${ancillaryPurchaseScope}.cfarItem`,
    defaultMessage:
      '{trip} · annulez sans justificatif jusqu’au {date} : {refund} remboursés',
    en: '{trip} · cancel with no proof until {date}: {refund} refunded',
    es: '{trip} · cancela sin justificante hasta el {date}: {refund} reembolsados',
    it: '{trip} · annulla senza giustificativo fino al {date}: {refund} rimborsati',
    de: '{trip} · ohne Nachweis stornieren bis {date}: {refund} erstattet',
    nl: '{trip} · annuleer zonder bewijs tot {date}: {refund} terugbetaald',
  },
  toPay: {
    id: `${ancillaryPurchaseScope}.toPay`,
    defaultMessage: 'À payer',
    en: 'To pay',
    es: 'A pagar',
    it: 'Da pagare',
    de: 'Zu zahlen',
    nl: 'Te betalen',
  },
  pay: {
    id: `${ancillaryPurchaseScope}.pay`,
    defaultMessage: 'Payer {price}',
    en: 'Pay {price}',
    es: 'Pagar {price}',
    it: 'Paga {price}',
    de: '{price} bezahlen',
    nl: '{price} betalen',
  },
  retry: {
    id: `${ancillaryPurchaseScope}.retry`,
    defaultMessage: 'Réessayer le paiement',
    en: 'Try the payment again',
    es: 'Reintentar el pago',
    it: 'Riprova il pagamento',
    de: 'Zahlung erneut versuchen',
    nl: 'Betaling opnieuw proberen',
  },
  separatePayment: {
    id: `${ancillaryPurchaseScope}.separatePayment`,
    defaultMessage: 'Paiement séparé, par carte. Vos billets ne changent pas.',
    en: 'Separate payment, by card. Your tickets do not change.',
    es: 'Pago aparte, con tarjeta. Tus billetes no cambian.',
    it: 'Pagamento separato, con carta. I tuoi biglietti non cambiano.',
    de: 'Separate Zahlung per Karte. Ihre Tickets bleiben unverändert.',
    nl: 'Aparte betaling, per kaart. Uw tickets veranderen niet.',
  },
  paymentFailed: {
    id: `${ancillaryPurchaseScope}.paymentFailed`,
    defaultMessage: 'Le paiement n’a pas abouti. Aucune somme n’a été débitée.',
    en: 'The payment did not go through. You were not charged.',
    es: 'El pago no se ha realizado. No se ha cobrado ningún importe.',
    it: 'Il pagamento non è andato a buon fine. Non è stato addebitato nulla.',
    de: 'Die Zahlung ist fehlgeschlagen. Es wurde nichts abgebucht.',
    nl: 'De betaling is niet gelukt. Er is niets afgeschreven.',
  },
  paymentNotStarted: {
    id: `${ancillaryPurchaseScope}.paymentNotStarted`,
    defaultMessage:
      'Le paiement n’a pas pu démarrer. Aucune somme n’a été débitée : réessayez.',
    en: 'The payment could not start. You were not charged: please try again.',
    es: 'El pago no ha podido iniciarse. No se ha cobrado nada: vuelve a intentarlo.',
    it: 'Il pagamento non è potuto partire. Non è stato addebitato nulla: riprova.',
    de: 'Die Zahlung konnte nicht gestartet werden. Es wurde nichts abgebucht: Bitte versuchen Sie es erneut.',
    nl: 'De betaling kon niet starten. Er is niets afgeschreven: probeer het opnieuw.',
  },
  unconfirmedTitle: {
    id: `${ancillaryPurchaseScope}.unconfirmedTitle`,
    defaultMessage: 'Paiement en cours de vérification',
    en: 'Payment being checked',
    es: 'Pago en verificación',
    it: 'Pagamento in verifica',
    de: 'Zahlung wird geprüft',
    nl: 'Betaling wordt gecontroleerd',
  },
  unconfirmedText: {
    id: `${ancillaryPurchaseScope}.unconfirmedText`,
    defaultMessage:
      'Nous attendons la confirmation de notre banque. Vous recevrez un reçu par email dès qu’elle arrive, et vos options seront actives.',
    en: 'We are waiting for our bank to confirm. You will get a receipt by email as soon as it does, and your options will be active.',
    es: 'Esperamos la confirmación de nuestro banco. Recibirás un recibo por email en cuanto llegue y tus opciones estarán activas.',
    it: 'Attendiamo la conferma della nostra banca. Riceverai una ricevuta via email appena arriva e le tue opzioni saranno attive.',
    de: 'Wir warten auf die Bestätigung unserer Bank. Sie erhalten eine Quittung per E-Mail, sobald sie eintrifft, und Ihre Optionen sind dann aktiv.',
    nl: 'We wachten op de bevestiging van onze bank. U ontvangt een betalingsbewijs per e-mail zodra die er is, en uw opties zijn dan actief.',
  },
  loadError: {
    id: `${ancillaryPurchaseScope}.loadError`,
    defaultMessage: 'Impossible d’afficher les options pour le moment.',
    en: 'We cannot show the options right now.',
    es: 'No podemos mostrar las opciones en este momento.',
    it: 'Al momento non possiamo mostrare le opzioni.',
    de: 'Die Optionen können gerade nicht angezeigt werden.',
    nl: 'We kunnen de opties nu niet tonen.',
  },
  reload: {
    id: `${ancillaryPurchaseScope}.reload`,
    defaultMessage: 'Réessayer',
    en: 'Try again',
    es: 'Reintentar',
    it: 'Riprova',
    de: 'Erneut versuchen',
    nl: 'Opnieuw proberen',
  },
  waitConfirmation: {
    id: `${ancillaryPurchaseScope}.waitConfirmation`,
    defaultMessage: 'Nous attendons la confirmation de votre paiement…',
    en: 'We are waiting for the confirmation of your payment…',
    es: 'Esperamos la confirmación de tu pago…',
    it: 'Attendiamo la conferma del tuo pagamento…',
    de: 'Wir warten auf die Bestätigung Ihrer Zahlung…',
    nl: 'We wachten op de bevestiging van uw betaling…',
  },
  paidTitle: {
    id: `${ancillaryPurchaseScope}.paidTitle`,
    defaultMessage: 'Votre option est active',
    en: 'Your option is active',
    es: 'Tu opción está activa',
    it: 'La tua opzione è attiva',
    de: 'Ihre Option ist aktiv',
    nl: 'Uw optie is actief',
  },
  paidText: {
    id: `${ancillaryPurchaseScope}.paidText`,
    defaultMessage: 'Vous allez recevoir le reçu par email.',
    en: 'You will receive the receipt by email.',
    es: 'Recibirás el recibo por email.',
    it: 'Riceverai la ricevuta via email.',
    de: 'Sie erhalten den Beleg per E-Mail.',
    nl: 'U ontvangt het ontvangstbewijs per e-mail.',
  },
  expiredTitle: {
    id: `${ancillaryPurchaseScope}.expiredTitle`,
    defaultMessage: 'Ce lien n’est plus valable',
    en: 'This link is no longer valid',
    es: 'Este enlace ya no es válido',
    it: 'Questo link non è più valido',
    de: 'Dieser Link ist nicht mehr gültig',
    nl: 'Deze link is niet meer geldig',
  },
  expiredText: {
    id: `${ancillaryPurchaseScope}.expiredText`,
    defaultMessage:
      'Votre voyage est passé, les options ne sont plus disponibles.',
    en: 'Your trip is over, the options are no longer available.',
    es: 'Tu viaje ya ha pasado, las opciones ya no están disponibles.',
    it: 'Il tuo viaggio è passato, le opzioni non sono più disponibili.',
    de: 'Ihre Reise ist vorbei, die Optionen sind nicht mehr verfügbar.',
    nl: 'Uw reis is voorbij, de opties zijn niet meer beschikbaar.',
  },
  nothingLeftTitle: {
    id: `${ancillaryPurchaseScope}.nothingLeftTitle`,
    defaultMessage: 'Vous avez déjà toutes les options disponibles',
    en: 'You already have all the options available',
    es: 'Ya tienes todas las opciones disponibles',
    it: 'Hai già tutte le opzioni disponibili',
    de: 'Sie haben bereits alle verfügbaren Optionen',
    nl: 'U heeft al alle beschikbare opties',
  },
  nothingLeftText: {
    id: `${ancillaryPurchaseScope}.nothingLeftText`,
    defaultMessage: 'Ou il est trop tard pour en ajouter à ce voyage.',
    en: 'Or it is too late to add any to this trip.',
    es: 'O es demasiado tarde para añadir más a este viaje.',
    it: 'Oppure è troppo tardi per aggiungerne a questo viaggio.',
    de: 'Oder es ist zu spät, dieser Reise welche hinzuzufügen.',
    nl: 'Of het is te laat om er aan deze reis toe te voegen.',
  },
  seeBooking: {
    id: `${ancillaryPurchaseScope}.seeBooking`,
    defaultMessage: 'Voir ma réservation',
    en: 'See my booking',
    es: 'Ver mi reserva',
    it: 'Vedi la mia prenotazione',
    de: 'Meine Buchung ansehen',
    nl: 'Mijn boeking bekijken',
  },
  seeBookings: {
    id: `${ancillaryPurchaseScope}.seeBookings`,
    defaultMessage: 'Voir mes réservations',
    en: 'See my bookings',
    es: 'Ver mis reservas',
    it: 'Vedi le mie prenotazioni',
    de: 'Meine Buchungen ansehen',
    nl: 'Mijn boekingen bekijken',
  },
  blockTitle: {
    id: `${ancillaryPurchaseScope}.blockTitle`,
    defaultMessage: 'Ajoutez des options à votre voyage',
    en: 'Add options to your trip',
    es: 'Añade opciones a tu viaje',
    it: 'Aggiungi opzioni al tuo viaggio',
    de: 'Fügen Sie Ihrer Reise Optionen hinzu',
    nl: 'Voeg opties toe aan uw reis',
  },
};

/** The name of each product */
export const ancillaryOfferTitles: Record<EAncillaryType, MessageDescriptor> = {
  [EAncillaryType.CFAR]: ancillaryPurchaseMessages.cfarTitle,
  [EAncillaryType.LAST_MINUTE]: ancillaryPurchaseMessages.lastMinuteTitle,
  [EAncillaryType.ZEN_RELAX]: ancillaryPurchaseMessages.zenRelaxTitle,
};
